// ============ بيانات المطوّرين: المصدر الوحيد (الاسم، اللوجو، السنة، النبذة، آخر المشاريع) ============
// الموقع كله بيقرا من هنا: جدار المطوّرين في الهوم + صفحة المطوّر + صفحة المشاريع + الـ SEO.
// مفيش ترتيب لازم يطابق ملف الترجمة تاني: كل مطوّر بياناته كاملة في مكان واحد.
//
// - ترتيب العرض = ترتيب العناصر في DEV_DETAILS تحت (غيّره بتحريك البلوك).
// - لإضافة مطوّر: ضيف عنصر جديد في DEV_DETAILS (slug فريد + logo + name + about ...) وضيف facts له في FACTS.
// - اللوجوهات: حطها في src/Assets، استوردها فوق (فيه imports جاهزة متعلّقة تحت)، وبدّل logo: null باسم المتغير.
// - price / q / y = null معناها مفيش رقم معلن. الواجهة بتعرض "على الطلب" أو "يُعلن قريبًا".
// - q و y = ربع وسنة التسليم المتوقعة. الحالات: "launch" | "underway" | "completed".
// - الأسعار "تبدأ من" بالدرهم حسب آخر إعلان (تحديث 12 أكتوبر 2026، وديار وعزيزي وسمانا وأرادَ والدار 19 أكتوبر 2026) وبتتغير مع كل مرحلة: راجعها قبل النشر.
// - النصوص: M(en, ar, ru, de, fr, es, it, he, zh). أي لغة مش مكتوبة بتاخد الإنجليزي (مناسب لأسماء المشاريع).

import emaar from "../Assets/Emaar-Properties-Logo-1.png";
import binghatti from "../Assets/binghatti (1).webp";
import danube from "../Assets/Danube-Logo.png";
import sobha from "../Assets/sobha-ZMhITtfQCc.png";
import meraas from "../Assets/Meraas-logo.svg";
import nakheel from "../Assets/nakheel.png";
import damac from "../Assets/damac.png";
import ellington from "../Assets/Eligiton.png";
// ⬇ فك التعليق عن كل سطر بعد ما تحط الصورة في src/Assets (وبدّل logo: null تحت باسم المتغير)
import omniyat from "../Assets/images__1_-removebg-preview.png";
import deyaar from "../Assets/Untitled-1_93876cab-cd3e-4385-97a9-48537b088fd2-removebg-preview.png";
import azizi from "../Assets/azizi.webp";
import samana from "../Assets/samana.png";
import arada from "../Assets/aradafile.png";
import aldar from "../Assets/images-removebg-preview.png";

// نص متعدد اللغات
export const M = (en, ar, ru, de, fr, es, it, he, zh) => {
  const o = { en };
  if (ar) o.ar = ar;
  if (ru) o.ru = ru;
  if (de) o.de = de;
  if (fr) o.fr = fr;
  if (es) o.es = es;
  if (it) o.it = it;
  if (he) o.he = he;
  if (zh) o.zh = zh;
  return o;
};
// للتوافق مع الكود القديم
export const L = (en, ar) => M(en, ar);
export const pick = (v, lang) => (v && (v[lang] ?? v.en)) || "";

export const TYPES = {
  apt: M("Apartments", "شقق", "Апартаменты", "Wohnungen", "Appartements", "Apartamentos", "Appartamenti", "דירות", "公寓"),
  vil: M("Villas", "فلل", "Виллы", "Villen", "Villas", "Villas", "Ville", "וילות", "别墅"),
  town: M("Townhouses", "تاون هاوس", "Таунхаусы", "Reihenhäuser", "Maisons de ville", "Adosados", "Case a schiera", "בתים טוריים", "联排别墅"),
  vt: M("Villas & Townhouses", "فلل وتاون هاوس", "Виллы и таунхаусы", "Villen & Reihenhäuser", "Villas et maisons de ville", "Villas y adosados", "Ville e case a schiera", "וילות ובתים טוריים", "别墅及联排别墅"),
  mix: M("Apartments & Townhouses", "شقق وتاون هاوس", "Апартаменты и таунхаусы", "Wohnungen & Reihenhäuser", "Appartements et maisons de ville", "Apartamentos y adosados", "Appartamenti e case a schiera", "דירות ובתים טוריים", "公寓及联排别墅"),
  com: M("Commercial", "تجاري", "Коммерческая", "Gewerbe", "Commercial", "Comercial", "Commerciale", "מסחרי", "商业"),
};

export const AREAS = {
  // دبي
  creek: M("Dubai Creek Harbour", "دبي كريك هاربر", "Дубай Крик Харбор"),
  emaarSouth: M("Emaar South", "إعمار الجنوب", "Эмаар Саут"),
  mina: M("Mina Rashid", "ميناء راشد", "Мина Рашид"),
  meydan: M("Nad Al Sheba, Meydan", "ند الشبا، ميدان", "Над Аль Шеба, Мейдан"),
  meydanHorizon: M("Meydan Horizon, MBR City", "ميدان هورايزن، مدينة محمد بن راشد", "Мейдан Хорайзон, MBR Сити"),
  rowaiyah: M("Dubailand (Al Rowaiyah)", "دبي لاند (الرواية)", "Дубайленд (Аль-Рувайя)"),
  majan: M("Majan", "مجان", "Маджан"),
  arjan: M("Arjan", "أرجان", "Арджан"),
  jvt: M("Jumeirah Village Triangle", "قرية جميرا المثلثة", "Джумейра Вилладж Трайангл"),
  jvc: M("Jumeirah Village Circle", "قرية جميرا الدائرية", "Джумейра Вилладж Серкл"),
  jumeirahIslands: M("Jumeirah Islands", "جزر جميرا", "Джумейра Айлендс"),
  academic: M("Dubai Academic City", "مدينة دبي الأكاديمية", "Дубай Академик Сити"),
  maritime: M("Dubai Maritime City", "مدينة دبي البحرية", "Дубай Маритайм Сити"),
  sufouh: M("Al Sufouh", "السفوح", "Аль-Суфух"),
  dubailand: M("Dubailand", "دبي لاند", "Дубайленд"),
  damacIslands: M("DAMAC Islands 2, Dubailand", "داماك آيلاندز 2، دبي لاند", "DAMAC Islands 2, Дубайленд"),
  downtown: M("Downtown Dubai", "وسط مدينة دبي", "Даунтаун Дубай"),
  dubaiSouth: M("Dubai South", "دبي الجنوب", "Дубай Саут"),
  dso: M("Dubai Silicon Oasis", "واحة دبي للسيليكون", "Дубай Силикон Оазис"),
  szr: M("Sheikh Zayed Road", "شارع الشيخ زايد", "Шейх Зайед Роуд"),
  lamer: M("La Mer, Jumeirah", "لا مير، جميرا", "Ла Мер, Джумейра"),
  citywalk: M("City Walk", "سيتي ووك", "Сити Уок"),
  nas: M("Nad Al Sheba", "ند الشبا", "Над Аль Шеба"),
  d3: M("Dubai Design District (d3)", "حي دبي للتصميم", "Дубайский район дизайна (d3)"),
  mjl: M("Madinat Jumeirah Living", "مدينة جميرا ليفينج", "Мадинат Джумейра Ливинг"),
  dubaiIslands: M("Dubai Islands", "دبي آيلاندز", "Дубай Айлендс"),
  meriva: M("Island B, Dubai Islands", "الجزيرة B، دبي آيلاندز", "Остров B, Дубай Айлендс", "Insel B, Dubai Islands", "Île B, Dubai Islands", "Isla B, Dubai Islands", "Isola B, Dubai Islands", "אי B, Dubai Islands", "Dubai Islands B 岛"),
  palmJebelAli: M("Palm Jebel Ali", "نخلة جبل علي", "Пальма Джебель Али"),
  palmJumeirah: M("Palm Jumeirah", "نخلة جميرا", "Пальма Джумейра"),
  // مطوّرين إضافيين (ديار، عزيزي، سمانا، أرادا، الدار)
  businessBay: M("Business Bay", "الخليج التجاري", "Бизнес-Бэй"),
  dpc: M("Park Five, Dubai Production City", "بارك فايف، مدينة دبي للإنتاج", "Park Five, Dubai Production City"),
  dja: M("Downtown Jebel Ali", "وسط مدينة جبل علي", "Даунтаун Джебель Али"),
  jaddaf: M("Al Jaddaf", "الجداف", "Аль-Джадаф"),
  aziziMilan: M("Azizi Milan, Dubai", "عزيزي ميلان، دبي", "Azizi Milan, Дубай"),
  furjan: M("Al Furjan", "الفرجان", "Аль-Фурджан"),
  mbr11: M("MBR City (District 11)", "مدينة محمد بن راشد (الحي 11)", "MBR Сити (District 11)"),
  studioCity: M("Dubai Studio City", "مدينة دبي للاستوديوهات", "Дубай Студио Сити"),
  intlCity: M("International City Phase 2", "المدينة العالمية المرحلة 2", "Интернешнл Сити, фаза 2"),
  zaabeel: M("Za'abeel", "زعبيل", "Заабиль"),
  dubaiHarbour: M("Dubai Harbour", "دبي هاربر", "Дубай Харбор"),
  jge: M("Jumeirah Golf Estates", "جميرا جولف إستيتس", "Джумейра Гольф Эстейтс"),
  athlon: M("Athlon, Dubailand", "أثلون، دبي لاند", "Athlon, Дубайленд"),
  saadiyat: M("Saadiyat Island, Abu Dhabi", "جزيرة السعديات، أبوظبي", "Остров Саадият, Абу-Даби", "Saadiyat Island, Abu Dhabi", "Île de Saadiyat, Abou Dhabi", "Isla Saadiyat, Abu Dabi", "Isola di Saadiyat, Abu Dhabi", "האי סעדיית, אבו דאבי", "阿布扎比萨迪亚特岛"),
  // أبوظبي
  bahiya: M("Al Bahiya, Abu Dhabi", "الباهية، أبوظبي", "Аль-Бахия, Абу-Даби", "Al Bahiya, Abu Dhabi", "Al Bahiya, Abou Dhabi", "Al Bahiya, Abu Dabi", "Al Bahiya, Abu Dhabi", "אל-בהייה, אבו דאבי", "阿布扎比 Al Bahiya"),
};

const A = AREAS;
const T = TYPES;
const SHARJAH = M("Sharjah, UAE", "الشارقة، الإمارات", "Шарджа, ОАЭ", "Sharjah, VAE", "Charjah, EAU", "Sharjah, EAU", "Sharjah, EAU", "שארג'ה, איחוד האמירויות", "阿联酋沙迦");
const ABU_DHABI = M("Abu Dhabi, UAE", "أبوظبي، الإمارات", "Абу-Даби, ОАЭ", "Abu Dhabi, VAE", "Abou Dhabi, EAU", "Abu Dabi, EAU", "Abu Dhabi, EAU", "אבו דאבי, איחוד האמירויות", "阿联酋阿布扎比");
const DUBAI = M("Dubai, UAE", "دبي، الإمارات", "Дубай, ОАЭ", "Dubai, VAE", "Dubaï, EAU", "Dubái, EAU", "Dubai, EAU", "דובאי, איחוד האמירויות", "阿联酋迪拜");

// p(name, area, type, priceAED, quarter, year, status)
const p = (name, area, type, price, q, y, status) => ({ name, area, type, price, q, y, status });

// ============ معلومات إضافية بتظهر في صفحة المطوّر (جنب سنة التأسيس والمقر) ============
// k = العنوان، v = القيمة. أي لغة مش مكتوبة بتاخد الإنجليزي.
const K = {
  founder: M("Founder", "المؤسس", "Основатель"),
  owner: M("Backed by", "المالك", "Собственник"),
  signature: M("Signature projects", "أبرز المشاريع", "Знаковые проекты"),
  delivered: M("Track record", "سجل الإنجاز", "Достижения"),
  partners: M("Brand partners", "الشركاء بالعلامات", "Бренд-партнёры"),
  listing: M("Listing", "الإدراج", "Листинг"),
  model: M("Approach", "نهج العمل", "Подход"),
  pipeline: M("Pipeline", "المشاريع قيد التنفيذ", "Портфель"),
};
const f = (k, v) => ({ k, v });

const FACTS = {
  emaar: [
    f(K.founder, M("Mohamed Alabbar", "محمد العبار", "Мохамед Алаббар")),
    f(K.signature, M("Burj Khalifa, Dubai Mall, Dubai Marina, Dubai Creek Harbour", "برج خليفة، دبي مول، دبي مارينا، دبي كريك هاربر", "Бурдж-Халифа, Dubai Mall, Дубай Марина, Dubai Creek Harbour")),
    f(K.listing, M("Dubai Financial Market", "سوق دبي المالي", "Дубайская финансовая биржа")),
  ],
  meraas: [
    f(K.owner, M("Dubai Holding", "دبي القابضة", "Dubai Holding")),
    f(K.signature, M("City Walk, Bluewaters Island, La Mer", "سيتي ووك، جزيرة بلووترز، لا مير", "City Walk, остров Bluewaters, La Mer")),
  ],
  nakheel: [
    f(K.owner, M("Dubai Holding", "دبي القابضة", "Dubai Holding")),
    f(K.signature, M("Palm Jumeirah, The World, Palm Jebel Ali, Dubai Islands", "نخلة جميرا، جزر العالم، نخلة جبل علي، دبي آيلاندز", "Пальма Джумейра, The World, Пальма Джебель Али, Dubai Islands")),
  ],
  omniyat: [
    f(K.founder, M("Mahdi Amjad, Executive Chairman", "مهدي أمجد، الرئيس التنفيذي للمجلس", "Махди Амджад, исполнительный председатель")),
    f(K.signature, M("The Opus, One at Palm Jumeirah, The Lana", "ذا أوبس، ون في نخلة جميرا، ذا لانا", "The Opus, One at Palm Jumeirah, The Lana")),
    f(K.pipeline, M("US$11.7B fully funded, under construction (Mar 2026)", "11.7 مليار دولار ممولة بالكامل قيد الإنشاء (مارس 2026)", "11,7 млрд долл. США, полностью профинансировано (март 2026)")),
  ],
  ellington: [
    f(K.signature, M("Upper House, Mercer House, The Meriva Collection", "أبر هاوس، ميرسر هاوس، مجموعة ميريفا", "Upper House, Mercer House, The Meriva Collection")),
    f(K.model, M("Design-led boutique residences", "مساكن راقية بتصميم مميز", "Бутик-резиденции с акцентом на дизайн")),
  ],
  damac: [
    f(K.founder, M("Hussain Sajwani", "حسين سجواني", "Хусейн Саджвани")),
    f(K.delivered, M("48,000+ homes delivered by 2025", "أكثر من 48 ألف وحدة سُلّمت بحلول 2025", "Более 48 000 домов сдано к 2025 году")),
    f(K.partners, M("Cavalli, Versace, de GRISOGONO", "كافالي، فيرساتشي، دي غريسوغونو", "Cavalli, Versace, de GRISOGONO")),
  ],
  binghatti: [
    f(K.founder, M("Muhammad Binghatti", "محمد بن غاطي", "Мухаммад Бингатти")),
    f(K.partners, M("Bugatti, Jacob & Co, Mercedes-Benz", "بوغاتي، جاكوب آند كو، مرسيدس-بنز", "Bugatti, Jacob & Co, Mercedes-Benz")),
    f(K.model, M("In-house design and construction", "تصميم وبناء داخليًا", "Собственное проектирование и строительство")),
  ],
  sobha: [
    f(K.founder, M("P.N.C. Menon (Sobha Group)", "بي. إن. سي. مينون (مجموعة صبحا)", "П. Н. К. Менон (Sobha Group)")),
    f(K.signature, M("Sobha Hartland, Sobha Sanctuary, Sobha SeaHaven", "صبحا هارتلاند، صبحا سانكتشواري، صبحا سي هيفن", "Sobha Hartland, Sobha Sanctuary, Sobha SeaHaven")),
    f(K.model, M("Vertically integrated, 6,819 handovers planned in 2026", "تكامل رأسي، وتسليم 6,819 وحدة مخطط في 2026", "Полный цикл, 6 819 передач ключей запланировано на 2026 год")),
  ],
  danube: [
    f(K.founder, M("Rizwan Sajan (Danube Group)", "رضوان ساجان (مجموعة دانوب)", "Ризван Саджан (Danube Group)")),
    f(K.delivered, M("32 projects launched, 16 delivered (mid-2026)", "32 مشروعًا أُطلق و16 سُلّم (منتصف 2026)", "32 проекта запущено, 16 сдано (середина 2026)")),
    f(K.model, M("Furnished homes, 1% monthly plans", "شقق مفروشة وخطة دفع 1% شهريًا", "Меблированные квартиры, рассрочка 1% в месяц")),
  ],
  deyaar: [
    f(K.owner, M("Dubai Islamic Bank", "بنك دبي الإسلامي", "Dubai Islamic Bank")),
    f(K.listing, M("Dubai Financial Market", "سوق دبي المالي", "Дубайская финансовая биржа")),
    f(K.delivered, M("30+ projects completed", "أكثر من 30 مشروعًا مُنجزًا", "Более 30 завершённых проектов")),
  ],
  azizi: [
    f(K.founder, M("Mirwais Azizi, Chairman", "ميرويس عزيزي، رئيس المجلس", "Мирваис Азизи, председатель")),
    f(K.delivered, M("200+ projects across the UAE", "أكثر من 200 مشروع في الإمارات", "Более 200 проектов в ОАЭ")),
    f(K.signature, M("Azizi Venice, Azizi Milan, Burj Azizi", "عزيزي فينيسيا، عزيزي ميلان، برج عزيزي", "Azizi Venice, Azizi Milan, Burj Azizi")),
  ],
  samana: [
    f(K.delivered, M("30+ active and upcoming projects", "أكثر من 30 مشروعًا قائمًا وقادمًا", "Более 30 текущих и будущих проектов")),
    f(K.model, M("Private pools, flexible payment plans", "مسابح خاصة وخطط دفع مرنة", "Личные бассейны, гибкие планы оплаты")),
  ],
  arada: [
    f(K.signature, M("Aljada, Masaar (Sharjah)", "الجادة، مسار (الشارقة)", "Aljada, Masaar (Шарджа)")),
    f(K.model, M("Dubai: Armani Beach Residences, W Residences Dubai Harbour, Jouri Hills", "في دبي: أرماني بيتش ريزيدنسز، دبليو ريزيدنسز دبي هاربر، جوري هيلز", "Дубай: Armani Beach Residences, W Residences Dubai Harbour, Jouri Hills")),
  ],
  aldar: [
    f(K.listing, M("Abu Dhabi Securities Exchange", "سوق أبوظبي للأوراق المالية", "Фондовая биржа Абу-Даби")),
    f(K.signature, M("Yas Island, Saadiyat Island", "جزيرة ياس، جزيرة السعديات", "Остров Яс, остров Саадият")),
    f(K.model, M("Dubai: Haven and Athlon with Dubai Holding", "في دبي: هيفن وأثلون بالشراكة مع دبي القابضة", "Дубай: Haven и Athlon вместе с Dubai Holding")),
  ],
};

// ============ المطوّرين (بالترتيب المطلوب) ============
const RAW_DEVS = [
  // ---------- 1) إعمار ----------
  {
    slug: "emaar",
    name: M("Emaar Properties", "إعمار العقارية"),
    mark: M("Emaar", "إعمار"),
    logo: emaar,
    since: 1997,
    projects: null,
    website: "https://www.emaar.com",
    hq: DUBAI,
    focus: M(
      "Master communities and landmarks",
      "مجتمعات متكاملة ومعالم بارزة",
      "Мастер-комьюнити и знаковые проекты",
      "Masterplan-Communities und Wahrzeichen",
      "Grandes communautés et sites emblématiques",
      "Comunidades planificadas y obras emblemáticas",
      "Grandi comunità pianificate e luoghi iconici",
      "קהילות מתוכננות ונקודות ציון איקוניות",
      "大型综合社区与地标项目"
    ),
    about: M(
      "Emaar is the Dubai developer behind Downtown Dubai with the Burj Khalifa and Dubai Mall, Dubai Marina, and newer communities such as Dubai Creek Harbour and Emaar South.",
      "إعمار شركة التطوير الدبية التي تقف خلف وسط مدينة دبي بما فيه برج خليفة ودبي مول، ودبي مارينا، ومجتمعات أحدث مثل دبي كريك هاربر وإعمار الجنوب.",
      "Emaar — дубайский девелопер, создавший Downtown Dubai с Бурдж-Халифой и Dubai Mall, Дубай Марину, а также новые районы, такие как Dubai Creek Harbour и Emaar South.",
      "Emaar ist der Dubaier Entwickler hinter Downtown Dubai mit dem Burj Khalifa und der Dubai Mall, der Dubai Marina sowie neueren Communities wie Dubai Creek Harbour und Emaar South.",
      "Emaar est le promoteur de Dubaï à l’origine de Downtown Dubai, avec le Burj Khalifa et le Dubai Mall, de Dubai Marina et de communautés plus récentes comme Dubai Creek Harbour et Emaar South.",
      "Emaar es la promotora de Dubái detrás de Downtown Dubai, con el Burj Khalifa y el Dubai Mall, de Dubai Marina y de comunidades más recientes como Dubai Creek Harbour y Emaar South.",
      "Emaar è il costruttore di Dubai dietro Downtown Dubai, con il Burj Khalifa e il Dubai Mall, Dubai Marina e comunità più recenti come Dubai Creek Harbour ed Emaar South.",
      "Emaar היא היזמית הדובאית שמאחורי Downtown Dubai עם בורג' ח'ליפה והדובאי מול, דובאי מרינה, ושכונות חדשות יותר כמו Dubai Creek Harbour ו-Emaar South.",
      "Emaar 是迪拜知名开发商，打造了拥有哈利法塔和迪拜购物中心的迪拜市中心、迪拜码头，以及 Dubai Creek Harbour 和 Emaar South 等新社区。"
    ),
    recent: [
      p(M("Valia", "فاليا"), A.creek, T.apt, 1960000, null, null, "launch"),
      p(M("Golf Fields", "جولف فيلدز"), A.emaarSouth, T.mix, 1260000, 3, 2030, "launch"),
      p(M("Golf Vale", "جولف فيل"), A.emaarSouth, T.mix, 1090000, null, 2030, "launch"),
      p(M("Golf Verge", "جولف فيرج"), A.emaarSouth, T.apt, 1200000, null, 2029, "launch"),
      p(M("Sera", "سيرا"), A.mina, T.apt, 2100000, null, null, "launch"),
    ],
  },

  // ---------- 2) ميراس ----------
  {
    slug: "meraas",
    name: M("Meraas", "ميراس"),
    mark: M("Meraas", "ميراس"),
    logo: meraas,
    since: 2007,
    projects: null,
    website: "https://www.meraas.com",
    hq: DUBAI,
    focus: M(
      "Lifestyle destinations in Dubai",
      "وجهات حياتية في دبي",
      "Лайфстайл-направления в Дубае",
      "Lifestyle-Destinationen in Dubai",
      "Destinations lifestyle à Dubaï",
      "Destinos de estilo de vida en Dubái",
      "Destinazioni lifestyle a Dubai",
      "יעדי לייף-סטייל בדובאי",
      "迪拜生活方式目的地"
    ),
    about: M(
      "Meraas, a member of Dubai Holding Real Estate, created City Walk, Bluewaters Island and La Mer, and is now building The Acres, Nad Al Sheba Gardens and a new Dubai Design District masterplan.",
      "ميراس، عضو في دبي القابضة العقارية، أنشأت سيتي ووك وجزيرة بلووترز ولا مير، وتبني حاليًا ذا إيكرز وحدائق ند الشبا ومخططًا جديدًا لحي دبي للتصميم.",
      "Meraas, входящая в Dubai Holding Real Estate, создала City Walk, остров Bluewaters и La Mer, а сейчас строит The Acres, Nad Al Sheba Gardens и новый мастер-план Dubai Design District.",
      "Meraas, Teil von Dubai Holding Real Estate, hat City Walk, Bluewaters Island und La Mer geschaffen und baut derzeit The Acres, Nad Al Sheba Gardens und einen neuen Masterplan für den Dubai Design District.",
      "Meraas, membre de Dubai Holding Real Estate, a créé City Walk, Bluewaters Island et La Mer, et construit aujourd’hui The Acres, Nad Al Sheba Gardens et un nouveau plan directeur pour le Dubai Design District.",
      "Meraas, parte de Dubai Holding Real Estate, creó City Walk, Bluewaters Island y La Mer, y ahora construye The Acres, Nad Al Sheba Gardens y un nuevo plan maestro para Dubai Design District.",
      "Meraas, parte di Dubai Holding Real Estate, ha creato City Walk, Bluewaters Island e La Mer, e oggi sta realizzando The Acres, Nad Al Sheba Gardens e un nuovo masterplan per il Dubai Design District.",
      "Meraas, חלק מ-Dubai Holding Real Estate, יצרה את City Walk, האי Bluewaters ו-La Mer, וכיום בונה את The Acres, את Nad Al Sheba Gardens ותוכנית אב חדשה ל-Dubai Design District.",
      "Meraas 隶属于 Dubai Holding Real Estate，打造了 City Walk、蓝水岛（Bluewaters Island）和 La Mer，目前正在建设 The Acres、Nad Al Sheba Gardens 以及迪拜设计区（d3）的新总体规划。"
    ),
    recent: [
      p(M("Solaya at La Mer", "سولايا في لا مير"), A.lamer, T.apt, null, null, null, "launch"),
      p(M("City Walk Crestlane 4 & 5", "كريستلين 4 و5 في سيتي ووك"), A.citywalk, T.apt, null, null, null, "launch"),
      p(
        M(
          "Nad Al Sheba Gardens (new phase)",
          "حدائق ند الشبا (مرحلة جديدة)",
          "Nad Al Sheba Gardens (новая фаза)",
          "Nad Al Sheba Gardens (neue Phase)",
          "Nad Al Sheba Gardens (nouvelle phase)",
          "Nad Al Sheba Gardens (nueva fase)",
          "Nad Al Sheba Gardens (nuova fase)",
          "Nad Al Sheba Gardens (שלב חדש)",
          "Nad Al Sheba Gardens（新一期）"
        ),
        A.nas,
        T.vt,
        null,
        null,
        null,
        "launch"
      ),
      p(M("The Edit at d3", "ذا إيديت في d3"), A.d3, T.apt, null, null, null, "underway"),
      p(M("Nourelle", "نوريل"), A.mjl, T.apt, null, null, null, "underway"),
    ],
  },

  // ---------- 3) نخيل ----------
  {
    slug: "nakheel",
    name: M("Nakheel", "نخيل"),
    mark: M("Nakheel", "نخيل"),
    logo: nakheel,
    since: 2000,
    projects: null,
    website: "https://www.nakheel.com",
    hq: DUBAI,
    focus: M(
      "Waterfront islands and iconic masterplans",
      "جزر ومجتمعات مائية ومخططات بارزة",
      "Острова у воды и знаковые мастер-планы",
      "Inseln am Wasser und ikonische Masterpläne",
      "Îles en bord de mer et plans directeurs emblématiques",
      "Islas frente al mar y planes maestros icónicos",
      "Isole sul mare e masterplan iconici",
      "איים על המים ותוכניות אב איקוניות",
      "海滨岛屿与标志性总体规划"
    ),
    about: M(
      "Nakheel, founded in 2000 and a member of Dubai Holding Real Estate, is the master developer behind Palm Jumeirah and The World, and is now delivering Palm Jebel Ali and Dubai Islands.",
      "نخيل، التي تأسست عام 2000 وهي عضو في دبي القابضة العقارية، هي المطوّر الرئيسي لنخلة جميرا وجزر العالم، وتنفّذ حاليًا نخلة جبل علي ودبي آيلاندز.",
      "Nakheel, основанная в 2000 году и входящая в Dubai Holding Real Estate, — мастер-девелопер Пальмы Джумейра и архипелага The World; сейчас компания реализует Пальму Джебель Али и Dubai Islands.",
      "Nakheel wurde 2000 gegründet, gehört zu Dubai Holding Real Estate und ist der Masterentwickler von Palm Jumeirah und The World; derzeit realisiert das Unternehmen Palm Jebel Ali und Dubai Islands.",
      "Fondé en 2000 et membre de Dubai Holding Real Estate, Nakheel est le maître d’ouvrage de Palm Jumeirah et de The World, et réalise aujourd’hui Palm Jebel Ali et Dubai Islands.",
      "Nakheel, fundada en 2000 y parte de Dubai Holding Real Estate, es la promotora principal de Palm Jumeirah y The World, y hoy desarrolla Palm Jebel Ali y Dubai Islands.",
      "Fondata nel 2000 e parte di Dubai Holding Real Estate, Nakheel è il master developer di Palm Jumeirah e The World e oggi sta realizzando Palm Jebel Ali e Dubai Islands.",
      "Nakheel, שנוסדה ב-2000 והיא חלק מ-Dubai Holding Real Estate, היא יזמית העל של פאלם ג'ומיירה ו-The World, וכיום מקימה את פאלם ג'בל עלי ואת Dubai Islands.",
      "Nakheel 成立于 2000 年，隶属于 Dubai Holding Real Estate，是朱美拉棕榈岛和世界群岛的总开发商，目前正在开发杰贝阿里棕榈岛和迪拜群岛（Dubai Islands）。"
    ),
    recent: [
      p(M("Bay Estate", "باي إستيت"), A.dubaiIslands, T.vt, null, null, null, "launch"),
      p(M("Beach & Coral Collection · Frond F", "مجموعة بيتش آند كورال · فروند F"), A.palmJebelAli, T.vil, null, null, null, "launch"),
      p(M("Palm Central Private Residences", "بالم سنترال برايفت ريزيدنسز"), A.palmJebelAli, T.apt, null, null, null, "launch"),
      p(M("Palm Beach Towers 2", "بالم بيتش تاورز 2"), A.palmJumeirah, T.apt, 2000000, 4, 2026, "underway"),
      p(M("Rixos Dubai Islands Hotel & Residences", "ريكسوس دبي آيلاندز للفنادق والإقامات"), A.dubaiIslands, T.apt, 2600000, 4, 2026, "underway"),
    ],
  },

  // ---------- 4) أومنيات ----------
  {
    slug: "omniyat",
    name: M("OMNIYAT", "أومنيات"),
    mark: M("OMNIYAT", "أومنيات"),
    logo: omniyat, // ⬅ حط اللوجو في src/Assets/omniyat.png وفك الـ import فوق وبدّل null بـ omniyat
    since: 2005,
    projects: null,
    website: "https://www.omniyat.com",
    hq: DUBAI,
    focus: M(
      "Ultra-luxury, design-led landmarks",
      "مشاريع فائقة الفخامة ومعالم بتصميم مميز",
      "Ультралюкс и знаковые проекты с акцентом на дизайн",
      "Ultraluxus und designorientierte Wahrzeichen",
      "Ultra-luxe et sites emblématiques axés sur le design",
      "Ultralujo y obras emblemáticas centradas en el diseño",
      "Ultra-lusso e luoghi iconici dal design ricercato",
      "יוקרה אולטרה ונקודות ציון בדגש על עיצוב",
      "超奢华、以设计为核心的地标项目"
    ),
    about: M(
      "OMNIYAT, founded in 2005 by Mahdi Amjad, is Dubai's ultra-luxury developer, known for The Opus designed by Zaha Hadid, One at Palm Jumeirah and The Lana, Dorchester Collection. In March 2026 it reported a fully funded US$11.7 billion pipeline under construction.",
      "أومنيات، التي أسسها مهدي أمجد عام 2005، مطوّر دبي المتخصص في العقارات فائقة الفخامة، وتُعرف بـ ذا أوبس من تصميم زها حديد، ووان في نخلة جميرا، وذا لانا من مجموعة دورتشستر. وفي مارس 2026 أعلنت عن محفظة مشاريع قيد الإنشاء بقيمة 11.7 مليار دولار ممولة بالكامل.",
      "OMNIYAT, основанная в 2005 году Махди Амджадом, — дубайский девелопер ультралюкс-класса, известный башней The Opus по проекту Захи Хадид, One at Palm Jumeirah и The Lana (Dorchester Collection). В марте 2026 года компания сообщила о полностью профинансированном портфеле строящихся проектов на 11,7 млрд долларов США.",
      "OMNIYAT wurde 2005 von Mahdi Amjad gegründet und ist Dubais Entwickler im Ultraluxus-Segment, bekannt für The Opus von Zaha Hadid, One at Palm Jumeirah und The Lana, Dorchester Collection. Im März 2026 meldete das Unternehmen eine voll finanzierte Pipeline von 11,7 Mrd. US-Dollar im Bau.",
      "Fondé en 2005 par Mahdi Amjad, OMNIYAT est le promoteur ultra-luxe de Dubaï, connu pour The Opus conçu par Zaha Hadid, One at Palm Jumeirah et The Lana, Dorchester Collection. En mars 2026, il a annoncé un portefeuille de 11,7 milliards de dollars en construction, entièrement financé.",
      "OMNIYAT, fundada en 2005 por Mahdi Amjad, es la promotora de ultralujo de Dubái, conocida por The Opus, diseñado por Zaha Hadid, One at Palm Jumeirah y The Lana, Dorchester Collection. En marzo de 2026 informó de una cartera de 11.700 millones de dólares en construcción, totalmente financiada.",
      "Fondata nel 2005 da Mahdi Amjad, OMNIYAT è il costruttore ultra-lusso di Dubai, noto per The Opus progettato da Zaha Hadid, One at Palm Jumeirah e The Lana, Dorchester Collection. A marzo 2026 ha dichiarato un portafoglio in costruzione da 11,7 miliardi di dollari, interamente finanziato.",
      "OMNIYAT, שנוסדה ב-2005 על ידי מהדי אמג'אד, היא יזמית היוקרה של דובאי, הידועה ב-The Opus שתכננה זהה חדיד, ב-One at Palm Jumeirah וב-The Lana של Dorchester Collection. במרץ 2026 דיווחה על פורטפוליו של 11.7 מיליארד דולר בבנייה, ממומן במלואו.",
      "OMNIYAT 由 Mahdi Amjad 于 2005 年创立，是迪拜的超奢华开发商，以扎哈·哈迪德设计的 The Opus、One at Palm Jumeirah 以及 The Lana（Dorchester Collection）闻名。2026 年 3 月，公司表示在建项目组合总值 117 亿美元，资金已全部到位。"
    ),
    recent: [
      p(M("Lumena Alta", "لومينا ألتا"), A.businessBay, T.com, null, 4, 2029, "launch"),
      p(M("The Alba Residences, Dorchester Collection", "ذا ألبا ريزيدنسز، مجموعة دورتشستر"), A.palmJumeirah, T.apt, null, null, 2028, "underway"),
      p(M("Orla, Dorchester Collection", "أورلا، مجموعة دورتشستر"), A.palmJumeirah, T.apt, null, 4, 2026, "underway"),
      p(M("Vela Viento", "فيلا فينتو"), A.businessBay, T.apt, null, 2, 2027, "underway"),
      p(M("AVA at Palm Jumeirah", "آفا في نخلة جميرا"), A.palmJumeirah, T.apt, null, 2, 2026, "underway"),
    ],
  },

  // ---------- 5) إيلينغتون ----------
  {
    slug: "ellington",
    name: M("Ellington Properties", "إيلينغتون العقارية"),
    mark: M("Ellington", "إيلينغتون"),
    logo: ellington,
    since: 2014,
    projects: null,
    website: "https://www.ellingtonproperties.ae",
    hq: DUBAI,
    focus: M(
      "Design-led boutique residences",
      "مساكن راقية بتصميم مميز",
      "Бутик-резиденции с акцентом на дизайн",
      "Designorientierte Boutique-Residenzen",
      "Résidences boutique axées sur le design",
      "Residencias boutique centradas en el diseño",
      "Residenze boutique dal design ricercato",
      "מגורי בוטיק בדגש על עיצוב",
      "以设计为核心的精品住宅"
    ),
    about: M(
      "Ellington Properties is a design-led Dubai developer established in 2014, known for boutique residences across the city, including Upper House and Mercer House in Uptown Dubai and the new Meriva Collection on Dubai Islands.",
      "إيلينغتون العقارية شركة تطوير دبية تأسست عام 2014 وتتميز بالتصميم، وتُعرف بمساكنها الراقية في أنحاء المدينة ومنها أبر هاوس وميرسر هاوس في أبتاون دبي ومجموعة ميريفا الجديدة في دبي آيلاندز.",
      "Ellington Properties — дубайский девелопер, основанный в 2014 году и делающий ставку на дизайн. Компания известна бутик-резиденциями по всему городу, включая Upper House и Mercer House в Uptown Dubai и новую коллекцию Meriva на Dubai Islands.",
      "Ellington Properties ist ein 2014 gegründeter, designorientierter Entwickler aus Dubai, bekannt für Boutique-Residenzen in der ganzen Stadt, darunter Upper House und Mercer House in Uptown Dubai sowie die neue Meriva Collection auf Dubai Islands.",
      "Ellington Properties est un promoteur de Dubaï fondé en 2014 et axé sur le design, connu pour ses résidences boutique dans toute la ville, dont Upper House et Mercer House à Uptown Dubai et la nouvelle Meriva Collection sur Dubai Islands.",
      "Ellington Properties es una promotora de Dubái fundada en 2014 y centrada en el diseño, conocida por sus residencias boutique en toda la ciudad, como Upper House y Mercer House en Uptown Dubai y la nueva Meriva Collection en Dubai Islands.",
      "Ellington Properties è un costruttore di Dubai fondato nel 2014 e guidato dal design, noto per le residenze boutique in tutta la città, tra cui Upper House e Mercer House a Uptown Dubai e la nuova Meriva Collection a Dubai Islands.",
      "Ellington Properties היא יזמית דובאית שנוסדה ב-2014 ושמה דגש על עיצוב. היא ידועה במגורי בוטיק ברחבי העיר, ביניהם Upper House ו-Mercer House ב-Uptown Dubai וקולקציית Meriva החדשה ב-Dubai Islands.",
      "Ellington Properties 是一家成立于 2014 年、以设计为核心的迪拜开发商，以遍布全城的精品住宅著称，包括 Uptown Dubai 的 Upper House 和 Mercer House，以及迪拜群岛全新的 Meriva Collection。"
    ),
    recent: [
      p(M("Everly Place", "إيفرلي بليس"), A.meydanHorizon, T.apt, 1900000, null, null, "launch"),
      p(M("The Meriva Collection", "مجموعة ميريفا"), A.meriva, T.apt, 2700000, null, null, "launch"),
      p(M("Eltiera Views", "إلتييرا فيوز"), A.jumeirahIslands, T.apt, null, null, null, "launch"),
      p(M("Windsor House", "ويندسور هاوس"), A.dubaiSouth, T.apt, 1200000, 4, 2028, "underway"),
      p(M("The Hillgate", "ذا هيلغيت"), A.dso, T.apt, 1300000, 4, 2027, "underway"),
    ],
  },

  // ---------- 6) داماك ----------
  {
    slug: "damac",
    name: M("DAMAC Properties", "داماك العقارية"),
    mark: M("DAMAC", "داماك"),
    logo: damac,
    since: 2002,
    projects: null,
    website: "https://www.damacproperties.com",
    hq: DUBAI,
    focus: M(
      "Branded residences and large communities",
      "مساكن بعلامات عالمية ومجتمعات كبيرة",
      "Брендированные резиденции и крупные комьюнити",
      "Markenresidenzen und große Communities",
      "Résidences de marque et grandes communautés",
      "Residencias de marca y grandes comunidades",
      "Residenze firmate e grandi comunità",
      "מגורי מותג וקהילות גדולות",
      "品牌住宅与大型社区"
    ),
    about: M(
      "DAMAC Properties, founded in 2002 by Hussain Sajwani, had delivered over 48,000 homes by 2025. It is known for DAMAC Hills, DAMAC Lagoons, DAMAC Islands and branded collaborations with Cavalli, Versace and de GRISOGONO.",
      "داماك العقارية، التي أسسها حسين سجواني عام 2002، سلّمت أكثر من 48 ألف وحدة بحلول 2025. تُعرف بداماك هيلز وداماك لاجونز وداماك آيلاندز وبتعاونها مع علامات مثل كافالي وفيرساتشي ودي غريسوغونو.",
      "DAMAC Properties, основанная Хусейном Саджвани в 2002 году, к 2025 году сдала более 48 000 домов. Компания известна проектами DAMAC Hills, DAMAC Lagoons, DAMAC Islands и коллаборациями с Cavalli, Versace и de GRISOGONO.",
      "DAMAC Properties wurde 2002 von Hussain Sajwani gegründet und hatte bis 2025 über 48.000 Wohneinheiten übergeben. Bekannt ist das Unternehmen für DAMAC Hills, DAMAC Lagoons, DAMAC Islands und Markenkooperationen mit Cavalli, Versace und de GRISOGONO.",
      "Fondé en 2002 par Hussain Sajwani, DAMAC Properties avait livré plus de 48 000 logements en 2025. Le groupe est connu pour DAMAC Hills, DAMAC Lagoons, DAMAC Islands et ses collaborations avec Cavalli, Versace et de GRISOGONO.",
      "DAMAC Properties, fundada en 2002 por Hussain Sajwani, había entregado más de 48.000 viviendas en 2025. Es conocida por DAMAC Hills, DAMAC Lagoons, DAMAC Islands y sus colaboraciones con Cavalli, Versace y de GRISOGONO.",
      "Fondata nel 2002 da Hussain Sajwani, DAMAC Properties aveva consegnato oltre 48.000 abitazioni entro il 2025. È nota per DAMAC Hills, DAMAC Lagoons, DAMAC Islands e per le collaborazioni con Cavalli, Versace e de GRISOGONO.",
      "DAMAC Properties, שהוקמה ב-2002 על ידי חוסיין סג'וואני, מסרה יותר מ-48,000 בתים עד 2025. היא ידועה בזכות DAMAC Hills, DAMAC Lagoons, DAMAC Islands ושיתופי פעולה עם Cavalli, Versace ו-de GRISOGONO.",
      "DAMAC Properties 由 Hussain Sajwani 于 2002 年创立，截至 2025 年已交付超过 48,000 套住宅。其知名项目包括 DAMAC Hills、DAMAC Lagoons、DAMAC Islands，并与 Cavalli、Versace 和 de GRISOGONO 等品牌合作。"
    ),
    recent: [
      p(M("DAMAC Islands 2", "داماك آيلاندز 2"), A.damacIslands, T.vt, 2750000, 2, 2030, "launch"),
      p(M("Chelsea Residences 2", "تشيلسي ريزيدنسز 2"), A.maritime, T.apt, 2960000, 4, 2029, "launch"),
      p(M("DAMAC Sun City", "داماك صن سيتي"), A.dubailand, T.town, 2250000, 1, 2028, "underway"),
      p(M("Coral Reef", "كورال ريف"), A.maritime, T.apt, 1660000, 1, 2028, "underway"),
      p(M("Volta", "فولتا"), A.downtown, T.apt, 1670000, 4, 2027, "underway"),
    ],
  },

  // ---------- 7) بن غاطي ----------
  {
    slug: "binghatti",
    name: M("Binghatti", "بن غاطي"),
    mark: M("Binghatti", "بن غاطي"),
    logo: binghatti,
    since: 2008,
    projects: null,
    website: "https://www.binghatti.com",
    hq: DUBAI,
    focus: M(
      "Branded towers and fast delivery",
      "أبراج بعلامات عالمية وتسليم سريع",
      "Брендированные башни и быстрая сдача",
      "Markentürme und schnelle Fertigstellung",
      "Tours de marque et livraison rapide",
      "Torres de marca y entrega rápida",
      "Torri firmate e consegne rapide",
      "מגדלי מותג ומסירה מהירה",
      "品牌大厦与快速交付"
    ),
    about: M(
      "Binghatti, founded in 2008, is known for its in-house design and construction and for branded projects with Bugatti, Jacob & Co and Mercedes-Benz.",
      "بن غاطي، التي تأسست عام 2008، تُعرف بالتصميم والبناء داخليًا وبمشاريعها بعلامات عالمية مع بوغاتي وجاكوب آند كو ومرسيدس-بنز.",
      "Binghatti, основанная в 2008 году, известна собственным проектированием и строительством, а также брендированными проектами с Bugatti, Jacob & Co и Mercedes-Benz.",
      "Binghatti wurde 2008 gegründet und ist bekannt für Planung und Bau aus eigener Hand sowie für Markenprojekte mit Bugatti, Jacob & Co und Mercedes-Benz.",
      "Fondé en 2008, Binghatti est connu pour sa conception et sa construction internes et pour ses projets de marque avec Bugatti, Jacob & Co et Mercedes-Benz.",
      "Binghatti, fundada en 2008, es conocida por diseñar y construir con equipos propios y por sus proyectos de marca con Bugatti, Jacob & Co y Mercedes-Benz.",
      "Fondata nel 2008, Binghatti è nota per progettare e costruire internamente e per i progetti firmati con Bugatti, Jacob & Co e Mercedes-Benz.",
      "Binghatti, שנוסדה ב-2008, ידועה בתכנון ובבנייה בכוחות עצמה ובפרויקטי מותג עם Bugatti, Jacob & Co ו-Mercedes-Benz.",
      "Binghatti 成立于 2008 年，以自主设计和施工著称，并推出了与 Bugatti、Jacob & Co 和 Mercedes-Benz 合作的品牌项目。"
    ),
    recent: [
      p(M("Mercedes-Benz Places | Binghatti City", "مرسيدس-بنز بليسز | بن غاطي سيتي"), A.meydan, T.apt, 1600000, 2, 2029, "launch"),
      p(M("Tilal Binghatti", "تلال بن غاطي"), A.rowaiyah, T.vt, null, null, null, "launch"),
      p(M("Binghatti Skyflame", "بن غاطي سكاي فليم"), A.majan, T.apt, 585000, 4, 2026, "underway"),
      p(M("Binghatti Hillcrest", "بن غاطي هيل كريست"), A.arjan, T.apt, 799999, 2, 2027, "underway"),
      p(M("Binghatti Luxuria", "بن غاطي لوكسوريا"), A.jvt, T.apt, null, 3, 2027, "underway"),
    ],
  },

  // ---------- 8) صبحا ----------
  {
    slug: "sobha",
    name: M("Sobha Realty", "صبحا العقارية"),
    mark: M("Sobha", "صبحا"),
    logo: sobha,
    since: 1976,
    projects: null,
    website: "https://www.sobharealty.com",
    hq: DUBAI,
    focus: M(
      "Luxury, vertically integrated",
      "فخامة وتكامل رأسي في البناء",
      "Люкс и полный цикл строительства",
      "Luxus, vertikal integriert",
      "Luxe et intégration verticale",
      "Lujo con integración vertical",
      "Lusso, filiera integrata",
      "יוקרה ושליטה מלאה בתהליך הבנייה",
      "奢华品质，垂直一体化"
    ),
    about: M(
      "Sobha Realty is the Dubai arm of Sobha Group, founded in 1976. It builds with an in-house, vertically integrated model and plans a record 6,819 handovers in Dubai in 2026.",
      "صبحا العقارية هي ذراع مجموعة صبحا، التي تأسست عام 1976، في دبي. تبني بنموذج متكامل رأسيًا داخليًا وتخطط لتسليم 6,819 وحدة في دبي خلال 2026، وهو رقم قياسي.",
      "Sobha Realty — дубайское подразделение Sobha Group, основанной в 1976 году. Компания строит по собственной вертикально интегрированной модели и планирует рекордные 6 819 передач ключей в Дубае в 2026 году.",
      "Sobha Realty ist der Dubaier Zweig der 1976 gegründeten Sobha Group. Das Unternehmen baut nach einem eigenen, vertikal integrierten Modell und plant für 2026 die Rekordzahl von 6.819 Übergaben in Dubai.",
      "Sobha Realty est la branche dubaïote du groupe Sobha, fondé en 1976. Elle construit selon un modèle interne verticalement intégré et prévoit un record de 6 819 remises de clés à Dubaï en 2026.",
      "Sobha Realty es la filial en Dubái de Sobha Group, fundado en 1976. Construye con un modelo propio integrado verticalmente y prevé un récord de 6.819 entregas en Dubái en 2026.",
      "Sobha Realty è la divisione di Dubai di Sobha Group, fondato nel 1976. Costruisce con un modello interno verticalmente integrato e prevede un record di 6.819 consegne a Dubai nel 2026.",
      "Sobha Realty היא זרוע דובאי של קבוצת Sobha, שנוסדה ב-1976. החברה בונה במודל עצמאי ומשולב אנכית ומתכננת שיא של 6,819 מסירות בדובאי ב-2026.",
      "Sobha Realty 是成立于 1976 年的 Sobha Group 在迪拜的分支，采用自有的垂直一体化建造模式，计划在 2026 年于迪拜交付创纪录的 6,819 套房产。"
    ),
    recent: [
      p(M("Sobha City", "مدينة صبحا"), A.bahiya, T.mix, null, 4, 2029, "launch"),
      p(M("Sobha Sanctuary · The Willows", "صبحا سانكتشواري · ذا ويلوز"), A.dubailand, T.vil, null, null, null, "launch"),
      p(M("Sobha Sanctuary · The Greens", "صبحا سانكتشواري · ذا جرينز"), A.dubailand, T.vil, null, null, 2029, "launch"),
      p(M("Sobha Sanctuary · The Brooks", "صبحا سانكتشواري · ذا بروكس"), A.dubailand, T.vil, null, null, 2029, "launch"),
      p(M("The Mirage at Sobha Central", "ذا ميراج في صبحا سنترال"), A.szr, T.apt, null, null, null, "underway"),
    ],
  },

  // ---------- 9) دانوب ----------
  {
    slug: "danube",
    name: M("Danube Properties", "دانوب العقارية"),
    mark: M("Danube", "دانوب"),
    logo: danube,
    since: 1993,
    projects: 32, // 32 مشروع أُطلق (16 منهم اتسلّموا) حسب تقرير يوليو 2026
    website: "https://www.danubeproperties.com",
    hq: DUBAI,
    focus: M(
      "Furnished homes, 1% monthly plans",
      "شقق مفروشة وخطط دفع 1% شهريًا",
      "Меблированные квартиры и рассрочка 1% в месяц",
      "Möblierte Wohnungen, 1 % Monatsraten",
      "Logements meublés, plans à 1 % par mois",
      "Viviendas amuebladas y planes del 1 % mensual",
      "Case arredate, piani all'1% mensile",
      "דירות מרוהטות ותשלום של 1% בחודש",
      "精装交付，每月 1% 付款计划"
    ),
    about: M(
      "Danube Properties, part of Danube Group founded in 1993, is known for fully furnished homes, a 1% monthly payment plan and celebrity-branded towers. By mid-2026 it had launched 32 projects and delivered 16 of them.",
      "دانوب العقارية، ضمن مجموعة دانوب التي تأسست عام 1993، تُعرف بالوحدات المفروشة بالكامل وخطة الدفع 1% شهريًا وأبراج بأسماء مشاهير. وبحلول منتصف 2026 أطلقت 32 مشروعًا وسلّمت 16 منها.",
      "Danube Properties, часть Danube Group (основана в 1993 году), известна полностью меблированными квартирами, рассрочкой 1% в месяц и башнями с именами знаменитостей. К середине 2026 года компания запустила 32 проекта и сдала 16 из них.",
      "Danube Properties gehört zur 1993 gegründeten Danube Group und ist bekannt für voll möblierte Wohnungen, einen Zahlungsplan mit 1 % pro Monat und Türme mit Prominentennamen. Bis Mitte 2026 hatte das Unternehmen 32 Projekte lanciert und 16 davon übergeben.",
      "Danube Properties, filiale du groupe Danube fondé en 1993, est connu pour ses logements entièrement meublés, son plan de paiement à 1 % par mois et ses tours associées à des célébrités. À la mi-2026, il avait lancé 32 projets et en avait livré 16.",
      "Danube Properties, parte de Danube Group, fundado en 1993, es conocida por sus viviendas totalmente amuebladas, su plan de pago del 1 % mensual y sus torres asociadas a celebridades. A mediados de 2026 había lanzado 32 proyectos y entregado 16.",
      "Danube Properties, parte di Danube Group fondato nel 1993, è nota per le case completamente arredate, il piano di pagamento all'1% mensile e le torri legate a celebrità. A metà 2026 aveva lanciato 32 progetti e ne aveva consegnati 16.",
      "Danube Properties, חלק מקבוצת Danube שנוסדה ב-1993, ידועה בדירות מרוהטות במלואן, בתוכנית תשלום של 1% בחודש ובמגדלים הקשורים לסלבריטאים. עד אמצע 2026 השיקה 32 פרויקטים ומסרה 16 מהם.",
      "Danube Properties 隶属于成立于 1993 年的 Danube Group，以全装修住宅、每月 1% 付款计划和名人冠名大厦著称。截至 2026 年年中，已推出 32 个项目，其中 16 个已交付。"
    ),
    recent: [
      p(M("Shahrukhz Residences", "شاهروخز ريزيدنس"), A.maritime, T.apt, 1650000, null, null, "launch"),
      p(M("Greenz by Danube", "جرينز من دانوب"), A.academic, T.vt, 3500000, 4, 2029, "launch"),
      p(M("Serenz by Danube", "سيرينز من دانوب"), A.jvc, T.apt, null, null, null, "launch"),
      p(M("Shahrukhz by Danube", "شاهروخز من دانوب"), A.sufouh, T.com, null, null, null, "underway"),
      p(M("Breez by Danube", "بريز من دانوب"), A.maritime, T.apt, 1400000, null, null, "underway"),
    ],
  },

  // ---------- 10) ديار للتطوير ----------
  {
    slug: "deyaar",
    name: M("Deyaar Development", "ديار للتطوير"),
    mark: M("Deyaar", "ديار"),
    logo: deyaar, // ⬅ حط اللوجو في src/Assets/deyaar.png وفك الـ import فوق وبدّل null بـ deyaar
    since: 2002,
    projects: null,
    website: "https://www.deyaar.ae",
    hq: DUBAI,
    focus: M(
      "Residential communities across Dubai",
      "مجتمعات سكنية في أنحاء دبي",
      "Жилые комплексы по всему Дубаю",
      "Wohnprojekte in ganz Dubai",
      "Résidences dans tout Dubaï",
      "Residencias en todo Dubái",
      "Residenze in tutta Dubai",
      "מתחמי מגורים ברחבי דובאי",
      "遍布迪拜的住宅社区"
    ),
    about: M(
      "Deyaar Development, founded in 2002 and based in Dubai, has completed more than 30 projects. Its current launches include DWTN Residences in Business Bay and the Park Five community in Dubai Production City.",
      "ديار للتطوير شركة دبية تأسست عام 2002، وأنجزت أكثر من 30 مشروعًا. ومن أحدث مشاريعها DWTN Residences في الخليج التجاري ومجتمع بارك فايف في مدينة دبي للإنتاج.",
      "Deyaar Development, основанная в 2002 году в Дубае, завершила более 30 проектов. Среди текущих запусков — DWTN Residences в Business Bay и комплекс Park Five в Dubai Production City.",
      "Deyaar Development wurde 2002 in Dubai gegründet und hat mehr als 30 Projekte fertiggestellt. Zu den aktuellen Launches gehören DWTN Residences in Business Bay und die Community Park Five in Dubai Production City.",
      "Fondé en 2002 à Dubaï, Deyaar Development a livré plus de 30 projets. Ses lancements récents comprennent DWTN Residences à Business Bay et la communauté Park Five à Dubai Production City.",
      "Deyaar Development, fundada en 2002 en Dubái, ha completado más de 30 proyectos. Entre sus lanzamientos actuales están DWTN Residences en Business Bay y la comunidad Park Five en Dubai Production City.",
      "Deyaar Development, fondata nel 2002 a Dubai, ha completato oltre 30 progetti. Tra i lanci attuali ci sono DWTN Residences a Business Bay e la comunità Park Five a Dubai Production City.",
      "Deyaar Development, שנוסדה ב-2002 בדובאי, השלימה יותר מ-30 פרויקטים. בין ההשקות הנוכחיות שלה: DWTN Residences ב-Business Bay ושכונת Park Five ב-Dubai Production City.",
      "Deyaar Development 于 2002 年在迪拜成立，已完成 30 多个项目。其最新项目包括 Business Bay 的 DWTN Residences 和 Dubai Production City 的 Park Five 社区。"
    ),
    recent: [
      p(M("DWTN Residences", "DWTN ريزيدنسز"), A.businessBay, T.apt, 1860000, 4, 2030, "launch"),
      p(M("Ivy at Park Five", "آيفي في بارك فايف"), A.dpc, T.apt, 685000, 4, 2027, "underway"),
      p(M("Eleve by Deyaar", "إيليف من ديار"), A.dja, T.apt, 556000, 2, 2027, "underway"),
      p(M("Mar Casa", "مار كاسا"), A.maritime, T.apt, 1280000, 4, 2026, "underway"),
      p(M("Tria", "تريا"), A.dso, T.apt, 518000, null, 2026, "completed"),
    ],
  },

  // ---------- 11) عزيزي للتطوير العقاري ----------
  {
    slug: "azizi",
    name: M("Azizi Developments", "عزيزي للتطوير العقاري"),
    mark: M("Azizi", "عزيزي"),
    logo: azizi, // ⬅ حط اللوجو في src/Assets/azizi.png وفك الـ import فوق وبدّل null بـ azizi
    since: 2007,
    projects: null,
    website: "https://azizidevelopments.com",
    hq: DUBAI,
    focus: M(
      "Large communities and landmark towers",
      "مجتمعات كبيرة وأبراج بارزة",
      "Крупные комьюнити и знаковые башни",
      "Große Communities und markante Türme",
      "Grandes communautés et tours emblématiques",
      "Grandes comunidades y torres emblemáticas",
      "Grandi comunità e torri iconiche",
      "קהילות גדולות ומגדלים איקוניים",
      "大型社区与地标塔楼"
    ),
    about: M(
      "Azizi Developments, founded in 2007 and chaired by Mirwais Azizi, has more than 200 projects across the UAE. It is building Azizi Venice in Dubai South, the Azizi Milan community and Burj Azizi on Sheikh Zayed Road, planned as one of the tallest towers in the world.",
      "عزيزي للتطوير العقاري، التي تأسست عام 2007 ويرأسها ميرويس عزيزي، لديها أكثر من 200 مشروع في الإمارات. وتبني حاليًا عزيزي فينيسيا في دبي الجنوب ومجتمع عزيزي ميلان وبرج عزيزي على شارع الشيخ زايد، المخطط ليكون من أطول أبراج العالم.",
      "Azizi Developments, основанная в 2007 году под руководством Мирваиса Азизи, реализует более 200 проектов в ОАЭ. Компания строит Azizi Venice в Dubai South, комплекс Azizi Milan и Burj Azizi на Шейх Зайед Роуд — одну из самых высоких башен мира.",
      "Azizi Developments wurde 2007 gegründet, wird von Mirwais Azizi geführt und hat mehr als 200 Projekte in den VAE. Das Unternehmen baut Azizi Venice in Dubai South, die Community Azizi Milan und Burj Azizi an der Sheikh Zayed Road, geplant als einer der höchsten Türme der Welt.",
      "Fondé en 2007 et présidé par Mirwais Azizi, Azizi Developments compte plus de 200 projets aux Émirats. Il construit Azizi Venice à Dubai South, la communauté Azizi Milan et Burj Azizi sur Sheikh Zayed Road, prévue comme l’une des plus hautes tours du monde.",
      "Azizi Developments, fundada en 2007 y presidida por Mirwais Azizi, tiene más de 200 proyectos en los EAU. Construye Azizi Venice en Dubai South, la comunidad Azizi Milan y Burj Azizi en Sheikh Zayed Road, prevista como una de las torres más altas del mundo.",
      "Azizi Developments, fondata nel 2007 e presieduta da Mirwais Azizi, conta oltre 200 progetti negli EAU. Sta realizzando Azizi Venice a Dubai South, la comunità Azizi Milan e Burj Azizi su Sheikh Zayed Road, progettata come una delle torri più alte del mondo.",
      "Azizi Developments, שנוסדה ב-2007 ובראשה מירוואיס עזיזי, מחזיקה ביותר מ-200 פרויקטים באיחוד האמירויות. החברה בונה את Azizi Venice ב-Dubai South, את קהילת Azizi Milan ואת Burj Azizi בשדרות שייח' זאיד, שמתוכנן להיות אחד המגדלים הגבוהים בעולם.",
      "Azizi Developments 成立于 2007 年，由 Mirwais Azizi 担任董事长，在阿联酋拥有 200 多个项目。目前正在建设 Dubai South 的 Azizi Venice、Azizi Milan 社区，以及谢赫扎耶德路上规划为全球最高塔楼之一的 Burj Azizi。"
    ),
    recent: [
      p(M("Burj Azizi", "برج عزيزي"), A.szr, T.apt, 7500000, 3, 2030, "launch"),
      p(M("Azizi Farishta 2", "عزيزي فاريشتا 2"), A.jaddaf, T.apt, 759000, 4, 2028, "launch"),
      p(M("Azizi Creek Views 4", "عزيزي كريك فيوز 4"), A.jaddaf, T.apt, 1100000, 4, 2028, "launch"),
      p(M("Azizi Milan Heights", "عزيزي ميلان هايتس"), A.aziziMilan, T.apt, 575000, 3, 2028, "launch"),
      p(M("Azizi Raffi", "عزيزي رافي"), A.furjan, T.apt, 686000, 1, 2028, "underway"),
    ],
  },

  // ---------- 12) سمانا للتطوير العقاري ----------
  {
    slug: "samana",
    name: M("Samana Developers", "سمانا للتطوير العقاري"),
    mark: M("Samana", "سمانا"),
    logo: samana, // ⬅ حط اللوجو في src/Assets/samana.png وفك الـ import فوق وبدّل null بـ samana
    since: 2018,
    projects: null,
    website: "https://www.samanadevelopers.com",
    hq: DUBAI,
    focus: M(
      "Apartments with private pools, flexible plans",
      "شقق بمسابح خاصة وخطط دفع مرنة",
      "Апартаменты с личными бассейнами, гибкие планы",
      "Wohnungen mit privatem Pool, flexible Pläne",
      "Appartements avec piscine privée, plans flexibles",
      "Apartamentos con piscina privada, planes flexibles",
      "Appartamenti con piscina privata, piani flessibili",
      "דירות עם בריכה פרטית ותשלומים גמישים",
      "带私人泳池的公寓，灵活付款"
    ),
    about: M(
      "Samana Developers, founded in 2018 and based in Business Bay, focuses on mid-luxury homes. It is known for apartments with private pools and flexible payment plans, and has more than 30 active and upcoming projects across Dubai.",
      "سمانا للتطوير العقاري، التي تأسست عام 2018 ومقرها الخليج التجاري، تركّز على المساكن الراقية بأسعار متوسطة. وتُعرف بشقق بمسابح خاصة وخطط دفع مرنة، ولديها أكثر من 30 مشروعًا قائمًا وقادمًا في دبي.",
      "Samana Developers, основанная в 2018 году со штаб-квартирой в Business Bay, работает в сегменте mid-luxury. Компания известна апартаментами с личными бассейнами и гибкими планами оплаты; у неё более 30 текущих и будущих проектов в Дубае.",
      "Samana Developers wurde 2018 gegründet, sitzt in Business Bay und konzentriert sich auf gehobene Wohnungen im mittleren Preissegment. Bekannt ist das Unternehmen für Wohnungen mit privatem Pool und flexible Zahlungspläne; es hat mehr als 30 laufende und geplante Projekte in Dubai.",
      "Fondé en 2018 et basé à Business Bay, Samana Developers cible le segment haut de gamme accessible. Il est connu pour ses appartements avec piscine privée et ses plans de paiement flexibles, et compte plus de 30 projets en cours ou à venir à Dubaï.",
      "Samana Developers, fundada en 2018 y con sede en Business Bay, se centra en viviendas de lujo medio. Es conocida por sus apartamentos con piscina privada y planes de pago flexibles, y tiene más de 30 proyectos activos y próximos en Dubái.",
      "Samana Developers, fondata nel 2018 e con sede a Business Bay, si concentra su residenze di fascia medio-alta. È nota per gli appartamenti con piscina privata e i piani di pagamento flessibili, e ha oltre 30 progetti attivi e in arrivo a Dubai.",
      "Samana Developers, שנוסדה ב-2018 ומשרדיה ב-Business Bay, מתמקדת בדירות יוקרה במחיר בינוני. היא ידועה בדירות עם בריכה פרטית ובתוכניות תשלום גמישות, ויש לה יותר מ-30 פרויקטים פעילים ועתידיים בדובאי.",
      "Samana Developers 成立于 2018 年，总部位于 Business Bay，专注于中高端住宅，以带私人泳池的公寓和灵活的付款计划著称，在迪拜拥有 30 多个在建及即将推出的项目。"
    ),
    recent: [
      p(M("Samana Ocean Crest", "سمانا أوشن كريست"), A.dubaiIslands, T.apt, 2150000, 2, 2028, "launch"),
      p(M("Rome 3 by Samana", "روما 3 من سمانا"), A.mbr11, T.apt, 2030000, 2, 2028, "launch"),
      p(M("Portside by Samana", "بورت سايد من سمانا"), A.dja, T.apt, 1100000, 2, 2029, "launch"),
      p(M("Greenfield 2 by Samana", "جرين فيلد 2 من سمانا"), A.intlCity, T.apt, 849000, 3, 2029, "launch"),
      p(M("Samana Mykonos", "سمانا ميكونوس"), A.studioCity, T.apt, 999000, 2, 2026, "underway"),
    ],
  },

  // ---------- 13) أرادَ ----------
  {
    slug: "arada",
    name: M("Arada", "أرادَ"),
    mark: M("Arada", "أرادَ"),
    logo: arada, // ⬅ حط اللوجو في src/Assets/arada.png وفك الـ import فوق وبدّل null بـ arada
    since: 2017,
    projects: null,
    website: "https://www.arada.com",
    hq: SHARJAH,
    focus: M(
      "Master communities and branded residences",
      "مجتمعات متكاملة ومساكن بعلامات عالمية",
      "Мастер-комьюнити и брендированные резиденции",
      "Masterplan-Communities und Markenresidenzen",
      "Grandes communautés et résidences de marque",
      "Comunidades planificadas y residencias de marca",
      "Grandi comunità e residenze firmate",
      "קהילות מתוכננות ומגורי מותג",
      "大型综合社区与品牌住宅"
    ),
    about: M(
      "Arada, founded in 2017 and based in Sharjah, is the developer behind the Aljada and Masaar communities. In Dubai it is building Armani Beach Residences on Palm Jumeirah, W Residences Dubai Harbour and Jouri Hills in Jumeirah Golf Estates.",
      "أرادَ، التي تأسست عام 2017 ومقرها الشارقة، هي المطوّر وراء مجتمعَي الجادة ومسار. وفي دبي تبني أرماني بيتش ريزيدنسز في نخلة جميرا ودبليو ريزيدنسز دبي هاربر وجوري هيلز في جميرا جولف إستيتس.",
      "Arada, основанная в 2017 году в Шардже, — девелопер комплексов Aljada и Masaar. В Дубае компания строит Armani Beach Residences на Пальме Джумейра, W Residences Dubai Harbour и Jouri Hills в Jumeirah Golf Estates.",
      "Arada wurde 2017 gegründet, sitzt in Sharjah und steht hinter den Communities Aljada und Masaar. In Dubai baut das Unternehmen Armani Beach Residences auf Palm Jumeirah, W Residences Dubai Harbour und Jouri Hills in Jumeirah Golf Estates.",
      "Fondé en 2017 et basé à Charjah, Arada est le promoteur des communautés Aljada et Masaar. À Dubaï, il construit Armani Beach Residences sur Palm Jumeirah, W Residences Dubai Harbour et Jouri Hills à Jumeirah Golf Estates.",
      "Arada, fundada en 2017 y con sede en Sharjah, es la promotora de las comunidades Aljada y Masaar. En Dubái construye Armani Beach Residences en Palm Jumeirah, W Residences Dubai Harbour y Jouri Hills en Jumeirah Golf Estates.",
      "Arada, fondata nel 2017 e con sede a Sharjah, è il costruttore delle comunità Aljada e Masaar. A Dubai sta realizzando Armani Beach Residences a Palm Jumeirah, W Residences Dubai Harbour e Jouri Hills a Jumeirah Golf Estates.",
      "Arada, שנוסדה ב-2017 ומשרדיה בשארג'ה, היא היזמית של קהילות Aljada ו-Masaar. בדובאי היא בונה את Armani Beach Residences בפאלם ג'ומיירה, את W Residences Dubai Harbour ואת Jouri Hills ב-Jumeirah Golf Estates.",
      "Arada 成立于 2017 年，总部位于沙迦，是 Aljada 和 Masaar 社区的开发商。在迪拜，它正在建设朱美拉棕榈岛的 Armani Beach Residences、W Residences Dubai Harbour 以及 Jumeirah Golf Estates 的 Jouri Hills。"
    ),
    recent: [
      p(M("Inaura Hotels & Residences", "إناورا للفنادق والإقامات"), A.downtown, T.apt, 3600000, 2, 2030, "launch"),
      p(M("Akala Hotels and Residences", "أكالا للفنادق والإقامات"), A.zaabeel, T.apt, 3800000, 4, 2029, "launch"),
      p(M("W Residences Dubai Harbour", "دبليو ريزيدنسز دبي هاربر"), A.dubaiHarbour, T.apt, 4140000, 4, 2028, "underway"),
      p(M("Armani Beach Residences", "أرماني بيتش ريزيدنسز"), A.palmJumeirah, T.apt, 21500000, 4, 2027, "underway"),
      p(M("Jouri Hills", "جوري هيلز"), A.jge, T.vt, 4900000, 3, 2027, "underway"),
    ],
  },

  // ---------- 14) الدار العقارية ----------
  {
    slug: "aldar",
    name: M("Aldar Properties", "الدار العقارية"),
    mark: M("Aldar", "الدار"),
    logo: aldar, // ⬅ حط اللوجو في src/Assets/aldar.png وفك الـ import فوق وبدّل null بـ aldar
    since: 2004,
    projects: null,
    website: "https://www.aldar.com",
    hq: ABU_DHABI,
    focus: M(
      "Abu Dhabi master developer, now in Dubai",
      "مطوّر رئيسي في أبوظبي يتوسع في دبي",
      "Мастер-девелопер Абу-Даби, теперь в Дубае",
      "Masterentwickler aus Abu Dhabi, jetzt in Dubai",
      "Grand promoteur d’Abou Dhabi, désormais à Dubaï",
      "Gran promotora de Abu Dabi, ahora en Dubái",
      "Grande costruttore di Abu Dhabi, ora a Dubai",
      "יזמית העל של אבו דאבי, עכשיו גם בדובאי",
      "阿布扎比总开发商，现已进入迪拜"
    ),
    about: M(
      "Aldar Properties, established in 2004, is a leading Abu Dhabi developer behind communities on Yas and Saadiyat islands. With Dubai Holding it is now building Haven and Athlon in Dubailand, its first communities in Dubai.",
      "الدار العقارية، التي تأسست عام 2004، من أبرز المطوّرين في أبوظبي، وتقف خلف مجتمعات في جزيرتَي ياس والسعديات. وتبني حاليًا بالشراكة مع دبي القابضة مجتمعَي هيفن وأثلون في دبي لاند، وهما أول مجتمعاتها في دبي.",
      "Aldar Properties, основанная в 2004 году, — один из ведущих девелоперов Абу-Даби, создатель комплексов на островах Яс и Саадият. Вместе с Dubai Holding компания строит Haven и Athlon в Дубайленде — свои первые проекты в Дубае.",
      "Aldar Properties wurde 2004 gegründet und ist einer der führenden Entwickler Abu Dhabis mit Communities auf Yas und Saadiyat Island. Gemeinsam mit Dubai Holding baut das Unternehmen Haven und Athlon in Dubailand, seine ersten Communities in Dubai.",
      "Fondé en 2004, Aldar Properties est l’un des principaux promoteurs d’Abou Dhabi, à l’origine de communautés sur les îles de Yas et de Saadiyat. Avec Dubai Holding, il construit Haven et Athlon à Dubailand, ses premières communautés à Dubaï.",
      "Aldar Properties, fundada en 2004, es una de las principales promotoras de Abu Dabi, con comunidades en las islas Yas y Saadiyat. Junto con Dubai Holding construye Haven y Athlon en Dubailand, sus primeras comunidades en Dubái.",
      "Aldar Properties, fondata nel 2004, è uno dei principali costruttori di Abu Dhabi, con comunità sulle isole di Yas e Saadiyat. Insieme a Dubai Holding sta realizzando Haven e Athlon a Dubailand, le sue prime comunità a Dubai.",
      "Aldar Properties, שנוסדה ב-2004, היא מהיזמיות המובילות באבו דאבי ועומדת מאחורי קהילות באיי יאס וסעדיית. יחד עם Dubai Holding היא בונה את Haven ו-Athlon ב-Dubailand, הקהילות הראשונות שלה בדובאי.",
      "Aldar Properties 成立于 2004 年，是阿布扎比领先的开发商，打造了亚斯岛和萨迪亚特岛上的多个社区。目前正与 Dubai Holding 合作在 Dubailand 建设 Haven 和 Athlon，这是其在迪拜的首批社区。"
    ),
    recent: [
      p(M("Rise by Athlon", "رايز من أثلون"), A.athlon, T.apt, 1350000, 4, 2029, "launch"),
      p(M("Athlon Townhouses & Villas", "تاون هاوس وفلل أثلون"), A.athlon, T.vt, 2800000, 2, 2028, "launch"),
      p(M("Haven by Aldar", "هيفن من الدار"), A.dubailand, T.vt, null, null, null, "underway"),
      p(M("Nouran Living", "نوران ليفينج"), A.saadiyat, T.apt, 750000, 4, 2027, "underway"),
      p(M("Saadiyat Lagoons", "السعديات لاجونز"), A.saadiyat, T.vil, 7964550, 3, 2027, "underway"),
    ],
  },
];

// ===== المصدر اللي الموقع كله بيقرا منه: نفس الترتيب + الـ facts =====
export const DEV_DETAILS = RAW_DEVS.map((d) => ({ ...d, facts: FACTS[d.slug] || [] }));

// ===== helpers =====
export const LOGOS = DEV_DETAILS.map((d) => d.logo); // للتوافق مع الكود القديم
export const getDeveloper = (slug) => DEV_DETAILS.find((d) => d.slug === slug);